import { FormControl, TextField } from '@mui/material'
import type { Control, Path, RegisterOptions } from 'react-hook-form'
import { Controller } from 'react-hook-form'

interface Props<T extends object> {
  name: string
  id: string
  label: string
  control: Control<T>
  rules: Omit<
    RegisterOptions<T, Path<T>>,
    'disabled' | 'valueAsNumber' | 'valueAsDate' | 'setValueAs'
  >
}

const MuiTextAreaField = <T extends object>({
  label,
  name,
  id,
  control,
  rules,
}: Props<T>) => (
  <FormControl fullWidth>
    <Controller<T>
      rules={rules}
      render={({ field: { onChange, value } }) => (
        <TextField
          fullWidth
          label={label}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          multiline
          minRows={15}
        />
      )}
      control={control}
      name={name as any}
    />
  </FormControl>
)

export default MuiTextAreaField
